import { BOT_MODE } from 'consts/enum';
import { LS } from 'consts/localStorage';
import { isLocalHost, readFromLs } from 'helpers/helpers';
import { ENGT_CHAT } from 'js/bot.model';

const getGeneratedParams = () => {
	const botLanguage = readFromLs(LS().USER_LOCALE) || ENGT_CHAT.get('config.botLanguage') || 'default';
	return `${ENGT_CHAT.get('config.bot_key')}?branding_key=${ENGT_CHAT.get(
		'config.branding_key'
	)}&lang_code=${botLanguage}`;
};

export const CSS_URL = () =>
	`${
		isLocalHost()
			? `${window.location.origin}/${
					ENGT_CHAT.get('config.bot_mode') === BOT_MODE.WIDGET ? 'widget' : 'standalone'
			  }`
			: `${ENGT_CHAT.get('config.brandedServer')}/static/${
					ENGT_CHAT.get('config.bot_mode') === BOT_MODE.WIDGET ? 'js/widget' : 'standalone/standalone'
			  }`
	}.css`;

export const ENDPOINT = () => {
	const botLanguage = readFromLs(LS().USER_LOCALE) || ENGT_CHAT.get('config.botLanguage') || 'default';
	const botURL = window.location.href;

	const urls = {
		ATTACHMENTS: '/v1.0/customer/attachment',
		INSTANCE: '/webchat_parameters/instance',
		BRANDING_KEY: `/portal/branding_element?url=${botURL}`,
		WIDGET_CONFIG: `/web/config/widget/${getGeneratedParams()}`,
		CHAT_CONFIG: `/web/config/chat/${getGeneratedParams()}`,
		GENERIC_STRING: `/web/generic-strings/${ENGT_CHAT.get('config.bot_key')}/?lang_code=${botLanguage}`,
		DOWNLOAD_URL: '/web/config/download-media/',
	};

	Object.keys(urls).map((url) => {
		urls[url] = ENGT_CHAT.get('config.brandedServer') + urls[url];
	});

	return urls;
};
export const EXT_ENDPOINT = () => ({
	IP_ADDRESS: 'https://api.ipify.org/?format=json',
	ATTACHMENTS: `${ENGT_CHAT.get('fileUploadBaseURL')}/v1.0/customer/attachment`,
	CART: `${window.location.origin}/cart/`,
	FAQ_AUTOCOMPLETE_PATH: `${ENGT_CHAT.get('faqAutocompleteBaseUrl')}/autocomplete/`,
	VOICE_LLM_STT_PATH: `${ENGT_CHAT.get('voiceLLMBaseUrl')}/api/v1.0/vls/speech-to-text/${ENGT_CHAT.get(
		'config.botRef'
	)}`,
});
